<template>
    <div>
        <div class="sc02_l" v-show="selectedRealtimeTab === 'Safety'">
            <span><i style="background:#e57373"></i>재난</span>
            <span><i style="background:#e5b87d"></i>화재</span>
            <span><i style="background:#92dd92"></i>구조</span>
            <span><i style="background:#91defa"></i>구급</span>
        </div>
        <div class="sc02_l" v-show="selectedRealtimeTab === 'Accident'">
            <span><i style="background:#e57373"></i>사고</span>
            <span><i style="background:#e5b87d"></i>공사</span>
            <span><i style="background:#92dd92"></i>행사</span>
            <span><i style="background:#91defa"></i>통제</span>
        </div>
        <div class="sc02_l" v-show="selectedRealtimeTab === 'Air' && ['pm10', 'pm25', 'no2'].includes(selectedRealtimeSubTab)">
            <span><i style="background:#91defa"></i>좋음</span>
            <span><i style="background:#92dd92"></i>보통</span>
            <span><i style="background:#e5b87d"></i>나쁨</span>
            <span><i style="background:#e57373"></i>매우나쁨</span>
            <span><i style="background:#797f82"></i>점검중</span>
        </div>
        <div class="sc02_l" v-show="selectedRealtimeTab === 'Air' && ['decibel'].includes(selectedRealtimeSubTab)">
            <span><i style="background:#91defa"></i>좋음</span>
            <span><i style="background:#92dd92"></i>보통</span>
            <span><i style="background:#e5b87d"></i>나쁨</span>
            <span><i style="background:#e57373"></i>최악</span>
            <span><i style="background:#797f82"></i>점검중</span>
        </div>
        <div class="sc02_l" v-show="selectedRealtimeTab === 'Air' && ['rain'].includes(selectedRealtimeSubTab)">
            <span><i style="background:#92dd92"></i>보통</span>
            <span><i style="background:#e5b87d"></i>주의</span>
            <span><i style="background:#e57373"></i>경보</span>
            <span><i style="background:#797f82"></i>점검중</span>
        </div>
        <div class="sc02_l" v-show="selectedRealtimeTab === 'Water'">
            <span><i style="background:#91defa"></i>정상</span>
            <span><i style="background:#e57373"></i>수질이상</span>
            <span><i style="background:#797f82"></i>점검중</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "SimplemapLegend",
    computed: {
        ...mapGetters({
            selectedRealtimeTab: 'getSelectedRealtimeTab',
            selectedRealtimeSubTab: 'getSelectedRealtimeSubTab',
        }),
    },
};
</script>
